import { render } from "./VotingForm.vue?vue&type=template&id=5cb2800f"
import script from "./VotingForm.vue?vue&type=script&lang=js"
export * from "./VotingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__